import React from 'react'
import Text from '../../components/text/Text'
import {IProbePhase} from './types'
import {phaseStateLabel} from './utils'

interface IProps {
    className?: string
    phases?: IProbePhase[]
}

const stateStyle = (phase: IProbePhase) => {
    if (phase.error) return 'text-font_red bg-tag_red_light'
    if (phase.unsupported) return 'text-font02 bg-bg_gray01'
    if (phase.ran) return 'text-font_green bg-tag_green_light'
    return 'text-font02 bg-bg_gray01'
}

const PHASE_DESC: Record<string, string> = {
    account: 'CheckNewKey — 읽기 전용. coinbase만 거래소를 호출하지 않고 미리 정해진 결과를 돌려줍니다.',
    balance: 'ProbeBalance — 읽기 전용. kucoin은 v2에 balance 조회 자체가 없습니다.',
    orders: '온디맨드 주문 조회. blofin을 뺀 나머지 거래소에서는 가져온 주문을 저장합니다.',
}

const PhaseTable: React.FC<IProps> = ({className, phases}) => {
    return (
        <div className={`bg-white rounded-[10px] p-[30px] shadow-normal ${className}`}>
            <Text className={'text-ti1 text-font01'}>Phases</Text>

            <div className={'mt-[20px] space-y-[10px]'}>
                {phases?.map(phase => (
                    <div key={phase.phase} className={'rounded-[8px] border border-line02 px-[16px] py-[12px]'}>
                        <div className={'flex items-center gap-x-[10px] flex-wrap'}>
                            <Text className={'text-ti2 text-font01'}>{phase.phase}</Text>
                            <Text className={`text-ti3 px-[7px] py-[2px] rounded-[5px] ${stateStyle(phase)}`}>
                                {phaseStateLabel(phase)}
                            </Text>
                            {/* 이 실행에서 읽기 전용이 아니었던 구간을 눈에 띄게 표시한다. */}
                            {phase.persists && (
                                <Text className={'text-ti3 px-[7px] py-[2px] rounded-[5px] text-white bg-tag_orange'}>
                                    저장됨
                                </Text>
                            )}
                            {phase.asset_count !== undefined && (
                                <Text className={'text-body3 text-font02'}>assets {phase.asset_count}</Text>
                            )}
                            {phase.code !== undefined && (
                                <Text className={'text-body3 text-font02'}>code {phase.code}</Text>
                            )}
                            <Text className={'text-body3 text-font03 ml-auto'}>{phase.duration_ms ?? 0}ms</Text>
                        </div>

                        {phase.error && <Text className={'text-body2 text-font_red mt-[6px]'}>{phase.error}</Text>}
                        {phase.note && <Text className={'text-body3 text-font02 mt-[6px]'}>{phase.note}</Text>}
                        {PHASE_DESC[phase.phase] && (
                            <Text className={'text-body3 text-font03 mt-[4px]'}>{PHASE_DESC[phase.phase]}</Text>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default PhaseTable
